import React from 'react';
import './NotFound.css';
import DashboardLayout from '../../layout/dashboard/dashboardLayout';
import { RavenButton } from '@ravenpay/raven-bank-ui';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
	return (
		<DashboardLayout>
			<div className="not-found-container">
				<div className="not-found-content">
					<div className="warning-icon">⚠️</div>
					<h1>Page not found</h1>
					<p>Sorry, the page you're looking for doesn't exist.</p>
					<div className="back-button">
						{/* Use Link over location.href to prevent full page reload */}
						<Link to={'/'}>
							<RavenButton
								label="go to safety"
								style={{
									marginTop: '2rem',
									display: '',
								}}
								color="deep-green-light"
								//onClick={() => (window.location.href = '/')}
							></RavenButton>
						</Link>
					</div>
				</div>
			</div>
		</DashboardLayout>
	);
};

export default NotFound;
